const DEBUG_ENABLED = import.meta.env.VITE_DEBUG_LOGS !== 'false';

const emit = (level, event, meta = {}) => {
    if (!DEBUG_ENABLED && level === 'debug') {
        return;
    }

    const payload = {
        event,
        ...meta,
        timestamp: new Date().toISOString()
    };

    console[level](`[survey-${level}]`, payload);
};

export const debugLog = (event, meta) => emit('debug', event, meta);
export const infoLog  = (event, meta) => emit('info', event, meta);
export const warnLog  = (event, meta) => emit('warn', event, meta);
export const errorLog = (event, meta) => emit('error', event, meta);
